import { createFileRoute, redirect } from '@tanstack/react-router'
import { CompanySettingsScreen } from '@/features/settings/settings-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for the company settings screen (design spec §6.2).
 *
 * The grant gate is presentation only — the API enforces `company.view` on
 * the settings endpoints; this only keeps a user without the grant out of a
 * screen they cannot use.
 */
export const Route = createFileRoute('/_authenticated/settings/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'company.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: CompanySettingsScreen,
})
